<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Histórico de Utilização
    </h1>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="main__content col-xl-12 px-2">
    <!-- <h2 class="col-12 pl-0 main__page__content__title">
        Filtre seu extrato de acordo com a data de pagamento
    </h2> -->
    <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
        (ngSubmit)="consultar()">
        <section class="content-form">
            <div class="col-12 mb-2 px-1">
                <label class="content__form__title__label">Selecione quem deseja consultar</label>
                <ng-select bindLabel="name" bindValue="id" placeholder="Selecione um Titular" [searchable]="false" [clearable]="false"
                    [items]="beneficiaries" formControlName="personCpf">
                </ng-select>
            </div>
            <div class="row">
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data inicio</label>
                    <input type="date" class="form-control input-form" formControlName="initialDate"
                        placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('initialDate')?.touched && formGroup.get('initialDate')?.invalid">
                        O campo Data inicio está inválido!
                    </small>
                </div>
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data fim</label>
                    <input type="date" class="form-control input-form" formControlName="finalDate"
                        placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('finalDate')?.touched && formGroup.get('finalDate')?.invalid">
                        O campo Data fim está inválido!
                    </small>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="content__form__title__label">Status do Atendimento</label>
                    <ng-select bindLabel="description" bindValue="id" placeholder="Status do atendimento" [searchable]="false"
                        [clearable]="false" [items]="serviceStatus" formControlName="serviceStatusId">
                    </ng-select>
                </div>
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="content__form__title__label">Prestador</label>
                    <ng-select class="convenantForm" type="text" bindLabel="tradeName" bindValue="convenantId" [searchable]="false"
                        [items]="convenants" placeholder="Digite o nome do prestador" [clearable]="true"
                        (search)="customSearchFn($event)" notFoundText="Nenhum resultado encontrado">
                    </ng-select>
                </div>
            </div>
        </section>
        <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
            [disabled]="this.loading">
            <div class="d-flex" *ngIf="loading; else showSpan">
                <span> Consultando</span>
            </div>
            <ng-template #showSpan>
                <span>Consultar</span>
            </ng-template>
        </button>
    </form>
    <ng-template #naoPossuiHistorico>
        <p class="col-12 aviso-sem-resultado">
            Não possui histórico
        </p>
    </ng-template>
    <section class="content__resultado__main mt-4" *ngIf="!loading; else showLoading">
        <div class="content_download_pdf">
            <div>
                <h3 class="content_download_pdf_title">
                    Exportar
                </h3>
            </div>
            <section class="d-flex">
                <button [disabled]="this.loading">
                    <div class="d-flex" *ngIf="loadingPdf; else showLoadingPdf">
                        <span class="spinner-button-export">
                        </span>
                    </div>
                    <ng-template #showLoadingPdf>
                        <fa-icon [icon]="faPdf" (click)="printPdf()"></fa-icon>
                    </ng-template>
                </button>
                <button [disabled]="this.loading">
                    <div class="d-flex" *ngIf="loadingCsv; else showLoadingCsv">
                        <span class="spinner-button-export">
                        </span>
                    </div>
                    <ng-template #showLoadingCsv>
                        <fa-icon [icon]="faExcel" (click)="printCsv()"></fa-icon>
                    </ng-template>
                </button>
            </section>
        </div>
        <header class="content__header">
            <h3 class="content__resultado__grid__header__title">Médico Hospitalar</h3>
            <filtro-dados [pageItens]="5" [totalItens]="beneficiary.doctorGuides.totalFiltered"
                *ngIf="beneficiary?.doctorGuides && beneficiary?.doctorGuides?.items && beneficiary?.doctorGuides?.items.length> 0"
                (changeQuantidade)="onChangeQuantidadeItens($event)">
            </filtro-dados>
        </header>
        <main
            *ngIf="beneficiary?.doctorGuides && beneficiary?.doctorGuides?.items && beneficiary?.doctorGuides?.items.length> 0; else naoPossuiHistorico">
            <section class="content__header__table">
                <div class="col-xl-1">Nº guia</div>
                <div class="col-xl-2">Atendimento</div>
                <div class="col-xl-3 display-sm-none">Prestador</div>
                <div class="col-xl-2">Data</div>
                <div class="col-xl-1 display-sm-none">Validade</div>
                <div class="col-xl-2 display-sm-none">Atendimento</div>
                <div class="col-xl-1">Ações</div>
            </section>
            <section class="content__main__table">
                <div class="table__card" *ngFor="let doctorGuide of beneficiary.doctorGuides?.items">
                    <div class="col-xl-1">{{doctorGuide.id}}</div>
                    <div class="col-xl-2">{{doctorGuide.serviceType}}</div>
                    <div class="col-xl-3 display-sm-none">{{doctorGuide.provider | slice: 0:20}}...</div>
                    <div class="col-xl-2">{{doctorGuide.serviceDate | date: 'dd/MM/yyyy'}}</div>
                    <div class="col-xl-1 display-sm-none">{{doctorGuide.expirationDate |
                        currency:'BRL':'symbol':'1.2-2':'pt' || '-'}}</div>
                    <div class="col-xl-2 display-sm-none">
                        <status [status]="doctorGuide.serviceStatus">
                        </status>
                    </div>
                    <div class="col-xl-1">
                        <a class="fa-icon" (click)="visualizarDetalhes(doctorGuide)">
                            <fa-icon [icon]="faEye"></fa-icon>
                        </a>
                    </div>
                </div>
            </section>
        </main>
        <footer>
            <paginacao [currentPage]="1" [collectionSize]="beneficiary.doctorGuides.totalFiltered"
                [pageSize]="myRequestsFilter.itemsPerPage" (changeNumber)="onChangePagination($event)"
                *ngIf="beneficiary?.doctorGuides?.items">
            </paginacao>
        </footer>
    </section>
</main>